import { ref, onMounted } from 'vue';
import { productService } from '@/api/product.service';

export function useProduct(productId: number | string) {
    const data = ref<Awaited<ReturnType<typeof productService.getDetails>> | null>(null);
    const loading = ref(false);
    const error = ref<unknown>(null);

    const load = async () => {
        loading.value = true;
        try {
            data.value = await productService.getDetails(productId);
        } catch (err) {
            error.value = err;
            console.error(err);
        } finally {
            loading.value = false;
        }
    };

    onMounted(load);
    return { data, loading, error, reload: load };
}
